export const toSnakeCase = (str: string): string =>
  str.replaceAll(/[A-Z]/g, (letter: string) => `_${letter.toLowerCase()}`);
